// API PATH
export const PRE_API_PATH: string = 'admin';

// NULL AS NUMBER
export const NULL_AS_NUMBER: number = null as unknown as number;

//USERNAME
export const USERNAME_REGEX: RegExp = /^(?![0-9])(?=[a-zA-Z0-9._]{6,100}$)(?!.*[_.]{2})[^_.].*[^_.]$/;

//PASSWORD
export const PASSWORD_REGEX: RegExp = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*()\-__+.]).{8,}$/);

// PHONE NUMBER (Cambodian local format: 9 or 10 digits, must start with 0)
export const PHONE_NUMBER_REGEX = /^0\d{8,9}$/;
